<app-card [cardOptionBtnValue]="'global.edit'|translate" [cardOptionBtn]="true"
          *ngIf="deliveryDealer.id"
          [cardRouterLink]="'back-office/crm/dealer/'+deliveryDealer.invoiceDealer.id+'/delivery/' + deliveryDealer.id"
          [title]="deliveryDealer.companyName">
  <div class="row">
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.user.address'|translate}}</p>
      <label class="m-b-15">{{deliveryDealer.address}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.user.zipCode'|translate}}</p>
      <label class="m-b-15">{{deliveryDealer.zipCode}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.user.city'|translate}}</p>
      <label class="m-b-15">{{deliveryDealer.city}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.user.country'|translate}}</p>
      <label class="m-b-15">{{deliveryDealer.country.name}}</label>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.user.email'|translate}}</p>
      <label class="m-b-15">{{deliveryDealer.email}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.user.phone'|translate}}</p>
      <label class="m-b-15">{{deliveryDealer.phone}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.user.website'|translate}}</p>
      <label class="m-b-15">{{deliveryDealer.website}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.user.status'|translate}}</p>
      <label class="m-b-15" [ngSwitch]="deliveryDealer.status">
        <span *ngSwitchCase="getDeliveryDealer().SYSTEMUSER_ACTIVE">{{'global.active'|translate}}</span>
        <span *ngSwitchCase="getDeliveryDealer().SYSTEMUSER_ON_HOLD">{{'global.on_hold'|translate}}</span>
        <span *ngSwitchCase="getDeliveryDealer().SYSTEMUSER_INACTIVE">{{'global.inactive'|translate}}</span>
      </label>
    </div>
  </div>
</app-card>
<app-card [title]="('admin.dealer.show.setting'|translate)">
  <nav ngbNav #nav="ngbNav" class="nav nav-tabs">
    <div ngbNavItem id="tab-users">
      <a ngbNavLink class="nav-link">{{'admin.dealer.show.users'|translate}}</a>
      <ng-template ngbNavContent>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>{{'doctrine.user.name'|translate}}</th>
              <th>{{'doctrine.user.username'|translate}}</th>
              <th>{{'doctrine.user.email'|translate}}</th>
              <th>{{'doctrine.user.role'|translate}}</th>
              <th>{{'doctrine.user.status'|translate}}</th>
              <th>{{'global.actions'|translate}}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let delivery of users">
              <td>{{delivery.contact}}</td>
              <td>{{delivery.username}}</td>
              <td>{{delivery.email}}</td>
              <td>{{delivery.role.name | translate}}</td>
              <td [ngSwitch]="delivery.status">
                <span *ngSwitchCase="getDeliveryDealer().SYSTEMUSER_ACTIVE">{{'global.active'|translate}}</span>
                <span *ngSwitchCase="getDeliveryDealer().SYSTEMUSER_ON_HOLD">{{'global.on_hold'|translate}}</span>
                <span *ngSwitchCase="getDeliveryDealer().SYSTEMUSER_INACTIVE">{{'global.inactive'|translate}}</span>
              </td>
              <td>
                <a *ngIf="!archive && delivery.role.name !== 'admin.dealer.role.admin'"  class="btn btn-lg btn-primary btn-icon ripple light ms-1"
                   (click)="openManageUserModal(delivery, false)">
                  <i class="fa fa-pencil"></i>
                </a>
                <a *ngIf="!archive && delivery.role.name !== 'admin.dealer.role.admin'" class="btn btn-lg btn-primary btn-icon ripple light ms-1"
                   (click)="showDeleteModal(delivery.id, delivery.contact)">
                  <i class="fa fa-remove"></i>
                </a>
                <a *ngIf="archive" class="btn btn-lg btn-primary btn-icon ripple light ms-1"
                   (click)="showReaddModal(delivery.id, delivery.contact)">

                  <i class="fa fa-plus"></i>
                </a>
              <td>
            </tr>
            </tbody>
          </table>
        </div>
        <button *ngIf="!archive" class="btn btn-primary ripple light pull-left my-3" type="button"
                (click)="openManageUserModal(null, false)">
          <i class="feather icon-plus ng-star-inserted"></i><label
          class="mb-0 ms-2"> {{ 'global.add' | translate}}</label>
        </button>
        <button class="btn btn-primary ripple light pull-right my-3" type="button" (click)="switchShowArchive()">
          {{ (archive ? 'admin.dealer.show.employee_users' : 'global.view_archive')|translate}}
        </button>
        <div class="clearfix"></div>
      </ng-template>
    </div>
    <div ngbNavItem id="tab-stock">
      <a ngbNavLink class="nav-link">{{'admin.dealer.show.dealer_points'|translate}}</a>
      <ng-template ngbNavContent>
        <div class="text-muted mt-4 mb-1" [innerText]="'admin.dealer.show.current_points'|translate"></div>
        <div [innerText]="'admin.dealer.show.total_point'|translate:{number: dealerUser.dealerPoints}"></div>
        <button class="btn btn-primary ripple light pull-left mt-4" type="button" (click)="showEditPoints()">
          {{ 'global.edit'|translate}}
        </button>
        <div class="clearfix"></div>
      </ng-template>
    </div>
    <div ngbNavItem id="tab-delivery-information">
      <a ngbNavLink class="nav-link">{{'admin.dealer.show.delivery_information_title'|translate}}</a>
      <ng-template ngbNavContent>

        <div>
          <div class="d-flex flex-wrap mt-4">
            <div class="d-flex flex-column text-start w-100">
              <p class="text-muted">{{'doctrine.delivery_contact.company_name'|translate}}</p>
              <p>{{contactInformation.companyName}}</p>
            </div>

            <div class="d-flex flex-column text-start w-25">
              <p class="text-muted">{{'doctrine.delivery_contact.address'|translate}}</p>
              <p>{{contactInformation.address}}</p>
            </div>
            <div class="d-flex flex-column text-start w-25">
              <p class="text-muted">{{'doctrine.delivery_contact.postal_code'|translate}}</p>
              <p>{{contactInformation.postalCode}}</p>
            </div>
            <div class="d-flex flex-column text-start w-25">
              <p class="text-muted">{{'doctrine.delivery_contact.city'|translate}}</p>
              <p>{{contactInformation.city}}</p>
            </div>
            <div class="d-flex flex-column text-start w-25">
              <p class="text-muted">{{'doctrine.delivery_contact.country'|translate}}</p>
              <p>{{contactInformation.country ? contactInformation.country.name : ''}}</p>
            </div>

            <div class="d-flex flex-column text-start w-25">
              <p class="text-muted">{{'doctrine.delivery_contact.contact_person'|translate}}</p>
              <p>{{contactInformation.contactPerson}}</p>
            </div>
            <div class="d-flex flex-column text-start w-25">
              <p class="text-muted">{{'doctrine.delivery_contact.email'|translate}}</p>
              <p>{{contactInformation.email}}</p>
            </div>
            <div class="d-flex flex-column text-start w-25">
              <p class="text-muted">{{'doctrine.delivery_contact.phone'|translate}}</p>
              <p>{{contactInformation.phone}}</p>
            </div>
            <div class="d-flex flex-column text-start w-25">
              <p class="text-muted">{{'doctrine.delivery_contact.advance_call'|translate}}</p>
              <p
                *ngIf="editDeliveryContact">{{(contactInformation.isAdvancedCall ? 'doctrine.delivery_contact.yes' : 'doctrine.delivery_contact.no') | translate}}</p>
            </div>

            <div class="d-flex flex-column text-start w-100">
              <p class="text-muted">{{'doctrine.delivery_contact.times'|translate}}</p>
            </div>
          </div>
          <div class="flex-column text-start" style="width: 18.5%;"
               *ngIf="contactInformation.mondayFrom || contactInformation.mondayTo">
            <div class="d-flex justify-content-between">
              <p class="text-start">{{'global.monday'|translate}}</p>
              <div class="flex">
                <span
                  *ngIf="contactInformation.mondayFrom">{{contactInformation.mondayFrom | date:'HH:mm':'UTC'}}</span>
                <span class="m-3" *ngIf="contactInformation.mondayFrom">| </span>
                <span
                  *ngIf="contactInformation.mondayTo">{{contactInformation.mondayTo | date:'HH:mm':'UTC'}}</span>
              </div>
            </div>
          </div>
          <div class="flex-column text-start" style="width: 18.5%;"
               *ngIf="contactInformation.tuesdayFrom || contactInformation.tuesdayTo">
            <div class="d-flex justify-content-between">
              <p class="text-start">{{'global.tuesday'|translate}}</p>
              <div class="flex">
                <span
                  *ngIf="contactInformation.tuesdayFrom">{{contactInformation.tuesdayFrom | date:'HH:mm':'UTC'}}</span>
                <span class="m-3" *ngIf="contactInformation.tuesdayFrom">| </span>
                <span
                  *ngIf="contactInformation.tuesdayTo">{{contactInformation.tuesdayTo | date:'HH:mm':'UTC'}}</span>
              </div>
            </div>
          </div>
          <div class="flex-column text-start" style="width: 18.5%;"

               *ngIf="contactInformation.wednesdayFrom || contactInformation.wednesdayTo">
            <div class="d-flex justify-content-between">
              <p class="text-start">{{'global.wednesday'|translate}}</p>
              <div class="flex">
                <span
                  *ngIf="contactInformation.wednesdayFrom">{{contactInformation.wednesdayFrom | date:'HH:mm':'UTC'}}</span>
                <span class="m-3" *ngIf="contactInformation.wednesdayFrom">| </span>
                <span
                  *ngIf="contactInformation.wednesdayTo">{{contactInformation.wednesdayTo | date:'HH:mm':'UTC'}}</span>
              </div>
            </div>
          </div>
          <div class="flex-column text-start" style="width: 18.5%;"
               *ngIf="contactInformation.thursdayFrom || contactInformation.thursdayTo">
            <div class="d-flex justify-content-between">
              <p class="text-start">{{'global.thursday'|translate}}</p>
              <div class="flex">
                <span
                  *ngIf="contactInformation.thursdayFrom">{{contactInformation.thursdayFrom | date:'HH:mm':'UTC'}}</span>
                <span class="m-3" *ngIf="contactInformation.thursdayFrom">| </span>
                <span
                  *ngIf="contactInformation.thursdayTo">{{contactInformation.thursdayTo | date:'HH:mm':'UTC'}}</span>
              </div>
            </div>
          </div>
          <div class="flex-column text-start" style="width: 18.5%;"
               *ngIf="contactInformation.fridayFrom || contactInformation.fridayTo">
            <div class="d-flex justify-content-between">
              <p class="text-start">{{'global.friday'|translate}}</p>
              <div class="flex">
                <span
                  *ngIf="contactInformation.fridayFrom">{{contactInformation.fridayFrom | date:'HH:mm':'UTC'}}</span>
                <span class="m-3" *ngIf="contactInformation.fridayFrom">| </span>
                <span
                  *ngIf="contactInformation.fridayTo">{{contactInformation.fridayTo | date:'HH:mm':'UTC'}}</span>
              </div>
            </div>
          </div>
        </div>

        <button class="btn btn-primary ripple light pull-right mt-4" type="button"
                (click)="showAddDeliveryContactModal()">
          {{(editDeliveryContact ? 'global.edit' : 'global.actions.add') | translate}}
        </button>
        <div class="clearfix"></div>
      </ng-template>
    </div>
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</app-card>

<app-manage-user
  *ngIf="showManageDealerUser"
  [currentDelivery]="deliveryUserId"
  [refresh]="refreshModal"
  [showModal]="showManageDealerUser"
  [userInput]="editingUser"
  [manageProfile]="manageProfile"
  (notifyParent)="refreshGrid($event)">
</app-manage-user>


<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'user'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <b [innerHTML]="userFullname"></b></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #readdModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'user'} }}</h4>
    <button type="button" class="close basic-close" (click)="readdModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}} : <b [innerHTML]="userFullname"></b></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="readdModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="readDealerUser()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>


<app-modal-basic #editPointModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_edit_title' | translate:{entity: 'dealer points'} }}</h4>
    <button type="button" class="close basic-close" (click)="editPointModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <app-classic-box #classicForm [classicBox]="classicBox" [data]="lastValue"
                     (changeForm)="enableButton($event)"></app-classic-box>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="editPointModal.hide()">{{'global.cancel'|translate}}</button>
    <button [disabled]="!enableSave" type="button" class="btn btn-primary ripple light"
            (click)="saveDealerPoint()">{{'global.actions.save'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #deliveryContactModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4
      class="modal-title">{{'admin.dealer.show.delivery_information_title'| translate}}</h4>
    <button type="button" class="close basic-close" (click)="hideDeliveryContactModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">

    <form novalidate #addNewDeliveryContact="ngForm">
      <div class="form-group row">
        <div class="form-group form-default form-static-label col-3">
          <label class="float-label">{{'doctrine.delivery_contact.company_name'|translate}} <span class="star">*</span></label>
          <input type="text" name="companyName" #companyName="ngModel" [(ngModel)]="deliveryContact.companyName"
                 class="form-control" required>
          <div class="messages text-danger"
               *ngIf="companyName.invalid && companyName.dirty && companyName.errors?.required">{{'errors.required'|translate}}
          </div>
        </div>
      </div>
      <h4 class="sub-title">{{'doctrine.delivery_contact.address' |translate}}</h4>
      <div class="form-group row">
        <div class="form-group form-default form-static-label col-3">
          <label class="float-label">{{'doctrine.delivery_contact.address'|translate}} <span
            class="star">*</span></label>
          <input type="text" name="address" #address="ngModel" [(ngModel)]="deliveryContact.address"
                 class="form-control" required>
          <div class="messages text-danger"
               *ngIf="address.invalid && address.dirty && address.errors?.required">{{'errors.required'|translate}}
          </div>
        </div>
        <div class="form-group form-default form-static-label col-3">
          <label class="float-label">{{'doctrine.delivery_contact.postal_code'|translate}} <span
            class="star">*</span></label>
          <input type="text" name="postalCode" #postalCode="ngModel" [(ngModel)]="deliveryContact.postalCode"
                 class="form-control" required>
          <div class="messages text-danger"
               *ngIf="postalCode.invalid && postalCode.dirty && postalCode.errors?.required">{{'errors.required'|translate}}
          </div>
        </div>
        <div class="form-group form-default form-static-label col-3">
          <label class="float-label">{{'doctrine.delivery_contact.city'|translate}} <span class="star">*</span></label>
          <input type="text" name="city" #city="ngModel" [(ngModel)]="deliveryContact.city" class="form-control"
                 required>
          <div class="messages text-danger"
               *ngIf="city.invalid && city.dirty && city.errors?.required">{{'errors.required'|translate}}
          </div>
        </div>
        <div class="form-group form-default form-static-label col-3">
          <label class="float-label">{{'doctrine.delivery_contact.country'|translate}} <span
            class="star">*</span></label>
          <ng-select [(ngModel)]="deliveryContact.country" id="country" name="countryItem"
                     #countryItem="ngModel" [searchable]="false" [clearable]="false" required>
            <ng-option *ngFor="let country of countries" [value]="country.id">{{country.name}} </ng-option>
          </ng-select>
          <div class="messages text-danger"
               *ngIf="countryItem.invalid && countryItem.dirty && countryItem.errors?.required">{{'errors.required'|translate}}
          </div>
        </div>
      </div>
      <h4 class="sub-title">{{'doctrine.delivery_contact.contacts' |translate}}</h4>
      <div class="form-group row">
        <div class="form-group form-default form-static-label col-3">
          <label class="float-label">{{'doctrine.delivery_contact.contact_person'|translate}}</label>
          <input type="text" name="contactPerson" #contactPerson="ngModel" [(ngModel)]="deliveryContact.contactPerson"
                 class="form-control">
        </div>
        <div class="form-group form-default form-static-label col-3">
          <label class="float-label">{{'doctrine.delivery_contact.email'|translate}} <span class="star">*</span></label>
          <input type="email" name="email" #email="ngModel" [(ngModel)]="deliveryContact.email" class="form-control"
                 required pattern=".+\@.+\..{2,}">
          <div class="messages text-danger"
               *ngIf="email.invalid && email.dirty && email.errors?.required">{{'errors.required'|translate}}
          </div>
          <div class="messages text-danger"
               *ngIf="email.invalid && email.dirty && email.errors?.pattern">{{'errors.invalid'|translate}}
          </div>
        </div>
        <div class="form-group form-default form-static-label col-3">
          <label class="float-label">{{'doctrine.delivery_contact.phone'|translate}}</label>
          <input type="text" name="phone" #phone="ngModel" [(ngModel)]="deliveryContact.phone" class="form-control">
        </div>
        <div class="col-sm-3 border-checkbox-section d-flex align-items-center mb-3">
          <div class="border-checkbox-group border-checkbox-group-primary">
            <div>
              <label>{{'doctrine.delivery_contact.advance_call'|translate}}</label>
              <div>
                <input type="checkbox" [id]="isAdvancedCall" class="border-checkbox" name="'isAdvancedCall'"
                       #isAdvancedCall="ngModel"
                       [(ngModel)]="deliveryContact.isAdvancedCall">
                <label class="border-checkbox-label mb-0"
                       [for]="isAdvancedCall">{{'doctrine.delivery_contact.yes'|translate}}</label>
              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
    <h4 class="sub-title">{{'doctrine.delivery_contact.times' |translate}}</h4>

    <div class="row mb-0 mt-0">
      <div class="col-md-1 d-flex align-items-center mb-0 mt-0 me-4">
        <p>{{'global.monday'|translate}}</p>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.mondayFrom" size="small" [spinners]="false"></ngb-timepicker>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.mondayTo" size="small" [spinners]="false"></ngb-timepicker>
      </div>
    </div>
    <div class="row mb-0 mt-0">
      <div class="col-md-1 d-flex align-items-center mb-0 mt-0 me-4">
        <p>{{'global.tuesday'|translate}}</p>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.tuesdayFrom" size="small" [spinners]="false"></ngb-timepicker>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.tuesdayTo" size="small" [spinners]="false"></ngb-timepicker>
      </div>
    </div>
    <div class="row mb-0 mt-0">
      <div class="col-md-1 d-flex align-items-center mb-0 mt-0 me-4">
        <p>{{'global.wednesday'|translate}}</p>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.wednesdayFrom" size="small" [spinners]="false"></ngb-timepicker>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.wednesdayTo" size="small" [spinners]="false"></ngb-timepicker>
      </div>
    </div>
    <div class="row mb-0 mt-0">
      <div class="col-md-1 d-flex align-items-center mb-0 mt-0 me-4">
        <p>{{'global.thursday'|translate}}</p>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.thursdayFrom" size="small" [spinners]="false"></ngb-timepicker>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.thursdayTo" size="small" [spinners]="false"></ngb-timepicker>
      </div>
    </div>
    <div class="row mb-0 mt-0">
      <div class="col-md-1 d-flex align-items-center mb-0 mt-0 me-4">
        <p>{{'global.friday'|translate}}</p>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.fridayFrom" size="small" [spinners]="false"></ngb-timepicker>
      </div>
      <div class="col-md-2 mb-0 mt-0">
        <ngb-timepicker [(ngModel)]="deliveryContact.fridayTo" size="small" [spinners]="false"></ngb-timepicker>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="hideDeliveryContactModal()">
      {{'global.cancel'|translate}}
    </button>
    <button type="button" class="btn btn-primary ripple light" (click)="manageDeliveryContact()"
            [disabled]="!addNewDeliveryContact.valid">
      {{'global.actions.save' | translate}}</button>
  </div>
</app-modal-basic>
